export var BettingOptionFormat;
(function (BettingOptionFormat) {
    BettingOptionFormat["DECIMAL"] = "decimal";
    BettingOptionFormat["AMERICAN"] = "american";
    BettingOptionFormat["FRACTIONAL"] = "fractional";
    BettingOptionFormat["HONGKONG"] = "hongkong";
})(BettingOptionFormat || (BettingOptionFormat = {}));
